/**
 * collar-personalization.js  v4b
 * Paws Paws Miami
 * Fixes: openCart uses section render API, sparse array bug resolved
 */

(function () {
  'use strict';

  const MAX    = 8;
  const TOKENS = new Set(['[PAW_PRINT]','[HEART]','[FLAMINGO]','[PALM_TREE]','[UNICORN]','[RAINBOW]']);

  /* ─── Letter image map ─── */
  function getLetterImg(letter) {
    const l = letter.toLowerCase();
    if (!/^[a-z]$/.test(l)) return null;
    if (window.ppmLetterAssets && window.ppmLetterAssets[l]) return window.ppmLetterAssets[l];
    return null;
  }

  /* ─── Charm image map ─── */
  function getCharmImg(token) {
    if (window.ppmCharmAssets && window.ppmCharmAssets[token]) return window.ppmCharmAssets[token];
    return null;
  }

  /* ─── State ─── */
  let pieces   = [];  // always a compact array, no sparse indices
  let selected = null;

  /* ─── DOM ─── */
  const wrap = document.getElementById('ppm-collar-builder');
  if (!wrap) return;

  const ID_TAG_VARIANT    = parseInt(wrap.dataset.idTagVariant,    10);
  const BEDAZZLED_VARIANT = parseInt(wrap.dataset.bedazzledVariant, 10);
  const AMERICANA_S = 54261709930771;
  const AMERICANA_M = 54261709963539;
  const AMERICANA_L = 54261709996307;
  

  const slotsEl    = document.getElementById('ppm-slots');
  const slotBtns   = Array.from(slotsEl.querySelectorAll('.ppm-slot'));
  const kbd        = document.getElementById('ppm-kbd');
  const counterEl  = document.getElementById('ppm-counter');
  const microEl    = document.getElementById('ppm-microcopy');
  const clearBtn   = document.getElementById('ppm-clear');
  const charmTiles = document.querySelectorAll('.ppm-charm-tile');
  const cbBedazzled= document.getElementById('ppm-cb-bedazzled');
  const cbTag      = document.getElementById('ppm-cb-tag');
  const tagFields  = document.getElementById('ppm-tag-fields');
  const frontInput = document.getElementById('ppm-front');
  const backInput  = document.getElementById('ppm-back');
  const frontError = document.getElementById('ppm-front-error');
  const atcMain    = document.getElementById('ppm-atc-main');
  const atcError   = document.getElementById('ppm-atc-error');
  const atcAnchor  = document.getElementById('ppm-atc-anchor');
  const cbAmericana    = document.getElementById('ppm-add-americana');
  const americanaSize  = document.getElementById('ppm-americana-size');
  const americanaWrap  = document.getElementById('ppm-americana-select-wrap');

  const defaultMicro = microEl.textContent;

  /* ─── Render ─── */
  function render() {
    slotBtns.forEach((btn, i) => {
      const piece  = pieces[i];
      const isSel  = selected === i;
      const letEl  = btn.querySelector('.ppm-slot__letter');
      const dotEl  = btn.querySelector('.ppm-slot__dot');

      btn.className = 'ppm-slot';

      if (piece) {
        if (piece.type === 'charm') {
          btn.classList.add('ppm-slot--charm');
          if (piece.imgSrc) {
            letEl.innerHTML = `<img src="${piece.imgSrc}" alt="${piece.value}" style="width:100%;height:100%;object-fit:contain;padding:2px;">`;
          } else {
            letEl.textContent = piece.value.replace(/[\[\]]/g, '').slice(0, 3);
          }
        } else {
          btn.classList.add('ppm-slot--filled');
          const imgSrc = piece.imgSrc || getLetterImg(piece.value);
          if (imgSrc) {
            letEl.innerHTML = `<img src="${imgSrc}" alt="${piece.value}" style="width:100%;height:100%;object-fit:contain;padding:2px;">`;
          } else {
            letEl.textContent = piece.value;
          }
        }
        dotEl.style.display = 'none';
        btn.setAttribute('aria-label', `Slot ${i + 1}: ${piece.value}. Tap to select.`);
      } else {
        letEl.innerHTML = '';
        letEl.textContent = '';
        dotEl.style.display = '';
        btn.classList.add('ppm-slot--empty');
        btn.setAttribute('aria-label', `Slot ${i + 1}: empty`);
      }

      if (isSel) btn.classList.add('ppm-slot--selected');
    });

    counterEl.textContent = `${pieces.length}/8`;
    counterEl.classList.toggle('ppm-counter--full', pieces.length === MAX);
    updateMicro();
   
  }

  function updateMicro(msg, isErr) {
    if (msg) {
      microEl.textContent = msg;
      microEl.classList.toggle('ppm-microcopy--error', !!isErr);
      return;
    }
    microEl.classList.remove('ppm-microcopy--error');
    microEl.textContent = pieces.length === MAX
      ? 'Max 8 pieces - your collar is full!'
      : defaultMicro;
  }

  
  /* ─── Insert ─── */
  function insert(type, value, imgSrc) {
    if (pieces.length >= MAX) {
      updateMicro('Max 8 pieces allowed.', true);
      return;
    }

    const resolvedImg = type === 'letter'
      ? (imgSrc || getLetterImg(value))
      : (imgSrc || getCharmImg(value) || null);

    const piece = { type, value, imgSrc: resolvedImg };

    // Always append to end — never use sparse index assignment
    // If a slot is selected, insert after that position
    if (selected !== null && selected < pieces.length) {
      // Insert after selected index
      pieces.splice(selected + 1, 0, piece);
      pop(selected + 1);
      selected = null;
    } else {
      // Append to end
      const at = pieces.length;
      pieces.push(piece);
      pop(at);
      selected = null;
    }

    render();
    clearAtcError();
  }

  function pop(i) {
    const btn = slotBtns[i];
    if (!btn) return;
    btn.classList.remove('ppm-slot--pop');
    void btn.offsetWidth;
    btn.classList.add('ppm-slot--pop');
  }

  /* ─── Delete ─── */
  function deletePiece() {
    if (selected !== null && pieces[selected]) {
      pieces.splice(selected, 1);
      selected = selected > 0 ? selected - 1 : null;
    } else if (pieces.length > 0) {
      pieces.splice(pieces.length - 1, 1);
      selected = null;
    }
    render();
  }

  /* ─── Keyboard ─── */
  slotsEl.addEventListener('pointerdown', () => kbd.focus({ preventScroll: true }));

  kbd.addEventListener('keydown', e => {
    if (e.key === 'Backspace') { e.preventDefault(); deletePiece(); return; }
    if (e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey) return;
    const ch = e.key.toUpperCase();
    if (/^[A-Z ]$/.test(ch)) { e.preventDefault(); insert('letter', ch, null); }
  });

  kbd.addEventListener('input', () => {
    const val = kbd.value;
    kbd.value = '';
    if (!val) return;
    for (const ch of val.toUpperCase()) {
      if (/^[A-Z ]$/.test(ch)) insert('letter', ch, null);
    }
  });

  /* ─── Slot clicks ─── */
  slotBtns.forEach((btn, i) => {
    btn.addEventListener('click', () => {
      selected = selected === i ? null : i;
      render();
      kbd.focus({ preventScroll: true });
    });
  });

  /* ─── Charm tiles ─── */
  charmTiles.forEach(tile => {
    tile.addEventListener('click', () => {
      const token   = tile.dataset.token;
      const tileImg = tile.querySelector('img');
      const imgSrc  = (tileImg ? tileImg.src : null) || getCharmImg(token);
      insert('charm', token, imgSrc);
      kbd.focus({ preventScroll: true });
    });
  });

  /* ─── Clear ─── */
  clearBtn.addEventListener('click', () => {
    pieces = []; selected = null;
    render(); clearAtcError();
  });

  /* ─── Upsell toggles ─── */
  cbTag.addEventListener('change', () => {
    const on = cbTag.checked;
    tagFields.hidden = !on;
    document.getElementById('ppm-upsell-tag').classList.toggle('ppm-upsell--checked', on);
    if (!on) {
      frontInput.classList.remove('ppm-field__input--error');
      frontError.hidden = true;
    }
  });

  cbBedazzled.addEventListener('change', () => {
    document.getElementById('ppm-upsell-bedazzled')
      .classList.toggle('ppm-upsell--checked', cbBedazzled.checked);
  });
  cbAmericana.addEventListener('change', () => {
    const on = cbAmericana.checked;
    americanaWrap.style.display = on ? 'block' : 'none';
    if (!on) americanaSize.value = '';
    document.getElementById('ppm-upsell-americana')
      .classList.toggle('ppm-upsell--checked', on);
  });
  frontInput.addEventListener('input', () => {
    if (frontInput.value.trim()) {
      frontInput.classList.remove('ppm-field__input--error');
      frontError.hidden = true;
    }
  });

  /* ─── Validation ─── */
  function validate() {
    clearAtcError();
    if (pieces.length === 0) {
      updateMicro('Please personalize your collar.', true);
      slotsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    if (cbTag.checked && !frontInput.value.trim()) {
      frontInput.classList.add('ppm-field__input--error');
      frontError.hidden = false;
      tagFields.scrollIntoView({ behavior: 'smooth', block: 'center' });
      frontInput.focus();
      return false;
    }
    return true;
  }

  /* ─── Cart ─── */
  function buildCollarProps() {
    return {
      'Customized':     pieces.map(p => p.value).join(' '),
      'Jewels tokens':  pieces.map(p => p.value).join(''),
      'Letters count':  pieces.filter(p => p.type === 'letter').length,
      'Charms count':   pieces.filter(p => p.type === 'charm').length,
      'Letters string': pieces.filter(p => p.type === 'letter').map(p => p.value).join(''),
      'Jewels count':   `${pieces.length}/8`
    };
  }

  function getCollarVariantId() {
    const el = document.querySelector('input[name="id"]');
    if (el && el.value) return parseInt(el.value, 10);
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) return window.ShopifyAnalytics.meta.selectedVariantId;
    if (window.__st?.v) return window.__st.v;
    return null;
  }

  async function addToCart() {
    if (!validate()) return;
    const variantId = getCollarVariantId();
    if (!variantId) { showAtcError('Could not read product variant. Please refresh.'); return; }

    const items = [{ id: variantId, quantity: 1, properties: buildCollarProps() }];
    if (cbBedazzled.checked) items.push({ id: BEDAZZLED_VARIANT, quantity: 1, properties: {} });
    if (cbTag.checked) {
      const props = { 'Front Engraving': frontInput.value.trim() };
      const back = backInput.value.trim();
      if (back) props['Back Engraving'] = back;
      items.push({ id: ID_TAG_VARIANT, quantity: 1, properties: props });
    }
if (cbAmericana.checked) {
  const selectedSize = americanaSize.value;
  if (!selectedSize) {
    showAtcError('Please select a size for the Americana Accessory Set.');
    setLoading(false);
    return;
  }
  items.push({ id: parseInt(selectedSize, 10), quantity: 1, properties: { _upsell: 'americana-accessory-set' } });
}
    setLoading(true);
    try {
      const res  = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (!res.ok) { showAtcError(data.description || data.message || 'Could not add to cart.'); setLoading(false); return; }
      setLoading(false);
      openCart();
    } catch (err) {
      console.error('[PPM]', err);
      showAtcError('Network error. Please try again.');
      setLoading(false);
    }
  }

  function openCart() {
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(r => r.json())
      .then(data => {
        const drawerEl = document.querySelector('#CartDrawer');
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (drawerEl && data['cart-drawer']) {
          const parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          const inner  = parsed.querySelector('#CartDrawer');
          if (inner) drawerEl.innerHTML = inner.innerHTML;
        }
        if (bubbleEl && data['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          const inner  = parsed.querySelector('#cart-icon-bubble');
          if (inner) bubbleEl.innerHTML = inner.innerHTML;
        }
const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer && typeof cartDrawer.open === 'function') {
  cartDrawer.open(); return;
}
// Fallback: click the cart icon to trigger Ride's native open
const cartIcon = document.getElementById('cart-icon-bubble');
if (cartIcon) { cartIcon.click(); return; }
window.location.href = '/cart';
      });
  }

  function setLoading(on) {
    [atcMain].forEach(btn => {
      const txt  = btn.querySelector('.ppm-atc__text');
      const spin = btn.querySelector('.ppm-atc__spin');
      btn.classList.toggle('ppm-atc--loading', on);
      btn.disabled = on;
      if (txt)  txt.hidden  = on;
      if (spin) spin.hidden = !on;
    });
  }

  function showAtcError(msg) { atcError.textContent = msg; atcError.hidden = false; }
  function clearAtcError()   { atcError.textContent = ''; atcError.hidden = true; }

  atcMain.addEventListener('click', addToCart);
 

  render();

})();